<template>
    <div class="login">
        <h4 class="login-title">Login</h4>
        <form @submit="login">
            <v-text-field
                v-model="form.email"
                label="Email"
                v-validate="'required|email'"
                data-vv-name="email"
                data-vv-as="email"
                :error-messages="errors.collect('email')"
            ></v-text-field>
            <v-text-field
                v-model="form.password"
                label="Password"
                type="password"
                v-validate="'required'"
                data-vv-name="password"
                data-vv-as="password"
                :error-messages="errors.collect('password')"
            ></v-text-field>
            <div class="buttons">
                <v-btn type="submit" class="login-button">Login</v-btn>
            </div>
        </form>
    </div>
</template>

<script>

export default {
    data() {
        return {
            form: {
                email: '',
                password: '',
            },
        };
    },
    methods: {
        async login(event) {
            event.preventDefault();
            const valid = await this.$validator.validate();

            if (valid) {
                await this.$store.dispatch('authentication/login', this.form);
                this.$router.push('/');
            }
        },
    },
};

</script>

<style lang="scss">
    @import '../../style/Authentication/LoginComponent.scss';
</style>
